import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CheckinNoteSavingQueue } from '../model/CheckinNoteSavingQueue';
import { useEffect } from 'react';
import { useToast } from '../../components/useToast';

export const CheckinSavingQueueErrorToast: React.FC<{ noteId: string; }> = ({ noteId }) => {
    const savingQueue = useInstance(CheckinNoteSavingQueue);
    useSubscription(() => savingQueue);

    const [present] = useToast();

    const error = savingQueue.getError({ noteId });

    useEffect(() => {
        if (error) {
            present({
                duration: 3000,
                message: (error as any).displayMessage || 'Sorry something went wrong'
            });
            setTimeout(() => {
                savingQueue.clearError({ noteId, error });
            }, 3000);
        }
    }, [error, present, savingQueue, noteId]);
    return null;
};
